<template>
  <div :class="containerClasses">
    <Heading v-if="title" :level="titleLevel" class="mb-4">{{ title }}</Heading>
    <slot></slot>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Heading from './Heading.vue'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  titleLevel: {
    type: String,
    default: 'h3'
  },
  padding: {
    type: String,
    default: 'p-6', // p-4, p-6, p-8, none
    validator: (value) => ['p-4', 'p-6', 'p-8', 'none'].includes(value)
  },
  variant: {
    type: String,
    default: 'card', // card, flat, bordered
    validator: (value) => ['card', 'flat', 'bordered'].includes(value)
  },
  noPadding: {
    type: Boolean,
    default: false
  },
  overflow: {
    type: Boolean,
    default: false
  }
})

const containerClasses = computed(() => {
  const classes = []
  
  // Base classes
  if (props.variant === 'card') {
    classes.push('bg-white dark:bg-gray-800 rounded-lg shadow-md')
  } else if (props.variant === 'bordered') {
    classes.push('bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700')
  }
  
  // Padding
  if (!props.noPadding) {
    classes.push(props.padding === 'none' ? '' : props.padding)
  }
  
  // Overflow
  if (props.overflow) {
    classes.push('overflow-auto')
  }
  
  return classes.filter(Boolean).join(' ')
})
</script>

